import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
// import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';

const TecEditpopMain = () => {


   var checkname=localStorage.getItem('username')

    let EditData = JSON.parse(localStorage.getItem("EditData"));


        let userName = EditData.map((item) => item.userName);

        let UserName = userName[0]
    
        let email= EditData.map((item) => item.email);
        let passwordHash=EditData.map((item) => item.passwordHash);

        let Email =email[0]
        let active= EditData.map((item) => item.active);

        let ActiveState = active[0]
   
        let id= EditData.map((item) => item.id)

        let Id= id[0]

        const token = JSON.parse(localStorage.getItem('usertoken'));


        function GeneratePassword() {
 

            var NewPass =Pass();
         
         
            console.log(NewPass)
            const body ={email: Email, newPassword:NewPass}
         
         
         axios({
              method: "POST",
              url :`${BASE_URL}/Tec/Generatepassword`,
               data:body, 
               headers: {
                "Content-Type": "application/json",
               
               }     
               }) 
               .then((response) =>{
                 console.log(response.data);
               
               
             if(response.data.status === "Success"){
                     document.getElementById("Gpass").innerHTML=NewPass;
                    //  toast.success("Password Generated " + "For"+ " "+ UserName, {
                    //    position: "top-center",
                    //    autoClose: 3200,
                    //    hideProgressBar: false,
                    //    closeOnClick: true,
                    //    pauseOnHover: true,
                    //    draggable: true,
                    //    progress: undefined,
                    //    className: 'toast-message'
                    //    });
                     
                    setPassToast(true)
                    
                    setTimeout(() => {
            
                      setPassToast(false)
                      
                    }, 2000);
                   }
                 })
                 .catch(error => {
                   console.log(error);
                   alert("failed !")
         
                 })
         
          }
         
          const Allowed = {
             Uppers: "QWERTYUIOPASDFGHJKLZXCVBNM",
             Lowers: "qwertyuiopasdfghjklzxcvbnm",
             Numbers: "1234567890",
             Symbols: "!@#$%^&*"
         }
         
         const getRandomCharFromString = (str) => str.charAt(Math.floor(Math.random() * str.length))
         
         /**
          * the generated password will be @param length, which default to 8, 
          * and will have at least one upper, one lower, one number and one symbol
          * @param {number} length - password's length
          * @returns a generated password
          */
         const Pass = (length = 8) => {
             let pwd = "";
             pwd += getRandomCharFromString(Allowed.Uppers);  // pwd will have at least one upper
             pwd += getRandomCharFromString(Allowed.Lowers);  // pwd will have at least one lower
             pwd += getRandomCharFromString(Allowed.Numbers);  // pwd will have at least one number
             pwd += getRandomCharFromString(Allowed.Symbols); // pwd will have at least one symbol
             for (let i = pwd.length; i < length; i++)
                 pwd += getRandomCharFromString(Object.values(Allowed).join(''));  // fill the rest of the pwd with random characters
             return pwd
         
            
         
         }


         const [Active, setActive] =useState(" ")

         ///function update

  function updatetec(){
    //var Security = document.getElementById("Gpassword").value
 
 
    if(Active===0){

      var Action =0
     }
     else if(Active===1){
      var Action= 1

     }

     else{
        var Action=ActiveState

     }
    
    // if(SPassword!=0){
        
    //   var SecurityPass = SPassword
    // }
    // else{
    //   var SecurityPass = Security

    // }
      
    // var Gpass = document.getElementById("Gpass").value;
    var EditName = document.getElementById("EditName").value;


    if(!EditName){
    document.getElementById("ErrA").innerHTML="UserName Required"

    }
    else if(EditName){

      document.getElementById("ErrA").innerHTML=" "

      const body =
      {
        
        userName:EditName, 
        id:Id,
        active:Action,
        normalizedUserName:EditName
       
     
      }
      console.log('body',body);

    
      axios({
             method:"POST",
             url :`${BASE_URL}/Tec/UpdateAspNetUser`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer " + `${token}`,
              }     
          }) 
  
         .then((response) =>{
         console.log(response.data);
    
    
         if(response.data.status === "Success"){

              setSuccessToast(true)
         
              // toast.success("Updated")
            
              //localStorage.setItem("EditData",JSON.stringify(response.data))
           
          
              //localStorage.setItem('username',EditName);

              //  setActive(false)

              // setInActive(false)

              if(checkname===UserName){

                localStorage.setItem('username',EditName);
            }
        

              setTimeout(() => {
                setSuccessToast(false)
                window.location.href="/?#/Tecadduser"
                
              }, 2000);
            }


            
    
      })
      .catch(error => {
        console.log(error);
      //  alert("failed !")
      alert("failed to Update")   
      })
        

    }
    

  }


  const[SuccessToast,setSuccessToast] = useState(false);  
  const[PassToast,setPassToast] = useState(false);  
  return (
    <>
    <>
    <div  className='tec-addmain'>


          
    
     {/* <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
        <div className='tec-addmain-back'>
           <Link to='/Tecadduser'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>EditUser</span>
 

     </div>
 </div> */}


<div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain">EDIT USER</span> </span>
 <div className='tec-addmain-back'>
  <Link to="/Tecadduser"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 

 {/* <hr></hr> */}
 </div>
    </div>   

              {/* Toast */}


              {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Updated Successfully</p></div>
   
  </div></div></div></div>:null}
 {/* Toast */}

  {PassToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Password Generated Successfully</p></div>
   
  </div></div></div></div>:null}








       {/* EditPopup */}


<div className="modal-dialog" role="document">
      <div className="modal-content">
      
   <form  id="edittecform" onSubmit={()=>updatetec()}>
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
       
          <input type="text" id="EditName"  defaultValue={userName} />
          <span id="ErrA" className='error'></span>
        </div> 
        <div className="md-form mb-5">

          <input type="text" defaultValue={email} readOnly/>

          </div>
        <div className="md-form mb-5">
        <input  value={passwordHash} id="Gpassword"/>
       {/* <input type="checkbox"   id="GenerateCheck" onClick={ChangePassword}/>&nbsp; */}
          <span className='col-sm-7'  id="Generatetecbox" ><span id="Gpass">Password</span></span> 
         <button id="Generatetecbtn" className='col-sm-4' type='button' onClick={GeneratePassword} >Generate</button>
    
         </div>
        
<div className="md-form mb-3">

  


{ActiveState===0 ? 
    <center>
 <input type="checkbox" id="tecactiveswitch"
              className="Activecheckbox"   onChange={()=>setActive(1)}/>
  <label for="tecactiveswitch" className="tectoggleactive">
       

<p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;Inactive</p>


  </label>

  </center>
:
<center>
<input type="checkbox" id="tecinactiveswitch"
         class="InActivecheckbox"  onChange={()=> setActive(0)} />
<label for="tecinactiveswitch" className="tectoggleinactive">
  

<p className='InActiveLable'>Active&nbsp; &nbsp;&nbsp;Inactive</p>


</label>

</center>


 


     }
{/* <button id ='oatInActive-buttonB' onClick={()=>ActiveStatus(e.id,e.active,e.userName)}>InActive</button> */}


</div>


       
      </div>
      <div className="modal-footer d-flex justify-content-center" id="teceditpopfooter">
        <button type="submit">Save Changes</button>
      </div>
      </form>
    </div>
  </div>



      
    
    </div>
    </>
    </>
  )
}

export default TecEditpopMain
